import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, PhoneCall, Mail } from "lucide-react";
import "./Footer.css";

export default function Footer() {
	return (
		<footer className="site-footer">
			<div className="footer-inner container">
				<div className="footer-brand">
					<h4>Triothought Tech Solutions Private Limited</h4>
					<p className="footer-address">
						No. 95A, Vyshnav Complex,<br />
						5th Floor Oppo KG Cinemas,<br />
						Race Course Coimbatore – 641018,<br />
						Tamil Nadu, India.
					</p>
					<div className="footer-contact-info">
						<div className="contact-item">
							<div className="contact-icon-wrapper">
								<PhoneCall size={14} strokeWidth={2.5} />
							</div>
							<a href="tel:+919488161565" className="contact-link">+91 94881 61565</a>
						</div>
						<div className="contact-item">
							<div className="contact-icon-wrapper">
								<Mail size={14} />
							</div>
							<a href="mailto:business@triothoughtsolution.com" className="contact-link">business@triothoughtsolution.com</a>
						</div>
					</div>
					<div className="footer-social">
						<a href="https://www.facebook.com/people/Trio-Thought/pfbid0GrpULzfCrqvGYkLA14vxt6FM5LGcKbR1VDgZZaVnmkmarPf3mcxX47brSw6V8TkJl/?rdid=Jk2qab05DN7yXAy3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1679t83B9C%2F" target="_blank" rel="noopener noreferrer" className="social-icon">
							<Facebook size={18} />
						</a>
						<a href="https://www.instagram.com/trio_thought_solutions?igsh=YThqeDMwcXowc3B3" target="_blank" rel="noopener noreferrer" className="social-icon">
							<Instagram size={18} />
						</a>
						<a href="https://www.linkedin.com/in/trio-thought-solutions-4b1493319" target="_blank" rel="noopener noreferrer" className="social-icon">
							<Linkedin size={18} />
						</a>
					</div>
				</div>
                
				<div className="footer-links">
					<h4>Useful Links</h4>
					<ul>
						<li><Link to="/">Home</Link></li>
						<li><Link to="/about">About us</Link></li>
						<li><Link to="/service-inpage">Services</Link></li>
						<li><Link to="/blogs-new">Blogs</Link></li>
						<li><Link to="/contact-new">Contact</Link></li>
					</ul>
				</div>

				<div className="footer-services">
					<h4>Our Services</h4>
					<ul>
						<li><Link to="/business-consulting">Business Consulting</Link></li>
						<li><Link to="/recruitment">Recruitment Process</Link></li>
						<li><Link to="/corporate-training">Corporate Training</Link></li>
						<li><Link to="/software-development">Software Development</Link></li>
					</ul>
				</div>
			</div>
			<div className="copyright">© 2026 <strong>Triothought Tech Solutions Private Limited</strong>. All Rights Reserved</div>
		</footer>
	);
}
